<script>
  export let title = '';
  export let icon = null;
  export let open = true;
  export let onToggle = () => {};
</script>

<section class="border-b border-slate-200">
  <button class="section-toggle" type="button" onclick={onToggle}>
    <span>
      {#if icon}
        <svelte:component this={icon} size={16} />
      {/if}
      {title}
    </span>
    {#if open}
      <svg viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"></path>
      </svg>
    {:else}
      <svg viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
        <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd"></path>
      </svg>
    {/if}
  </button>

  {#if open}
    <slot />
  {/if}
</section>

<style>
  .section-toggle {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.8rem 1rem;
    color: #0f172a;
    font-size: 0.875rem;
    font-weight: 600;
    text-align: left;
  }

  .section-toggle span {
    display: inline-flex;
    min-width: 0;
    align-items: center;
    gap: 0.5rem;
  }
</style>
